/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/aria-role */
/* eslint-disable jsx-a11y/media-has-caption */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable no-inner-declarations */
/* eslint-disable consistent-return */
/* eslint-disable no-restricted-syntax */
/* eslint-disable no-alert */
/* eslint-disable camelcase */
import React, {
  useState, useEffect, useRef, useContext, useCallback,
} from 'react';
import {
  Modal, Button, Grid, Typography, Backdrop, Fade, Slider,
} from '@material-ui/core';
import { Link, useHistory } from 'react-router-dom';

import clsx from 'clsx';

// social media

// icons
import { Close, VolumeUp, VolumeOff } from '@material-ui/icons';
import PlayCircleOutlineOutlinedIcon from '@material-ui/icons/PlayCircleOutlineOutlined';
import PauseCircleOutlineOutlinedIcon from '@material-ui/icons/PauseCircleOutlineOutlined';
import ReplayOutlinedIcon from '@material-ui/icons/ReplayOutlined';
import ReplyOutlinedIcon from '@material-ui/icons/ReplyOutlined';
import HighlightOffIcon from '@material-ui/icons/HighlightOff';
import ReportIcon from '@material-ui/icons/Report';

import Popover from '@material-ui/core/Popover';

import './ShortVideoPlayer.css';

import Swal from 'sweetalert2';

// New Login Modal Component
import Cookies from 'js-cookie';
import { makeStyles } from '@material-ui/core/styles';
import axios from '@shared/config/baseAPI';
import BanUser from '@features/UserAccountBan';
import { getUser } from '@shared/services/userApi';
import LoginModalComponent from '@features/Authentication';
import whatsapp from '@assets/images/social-media-icons/whatsapp.png';
import facebook from '@assets/images/social-media-icons/share-facebook.png';
import messenger from '@assets/images/social-media-icons/messenger.png';
import { UserContext } from '@context/UserContext';

const useStyles = makeStyles((theme) => ({
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: '9999',
  },
  paper: {
    borderRadius: '10px',
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    color: '#000',
    width: '100%',
    [theme.breakpoints.up('sm')]: {
      maxWidth: '500px',
      height: '250px',
    },
    [theme.breakpoints.down('sm')]: {
      height: '320px',
      maxWidth: '350px',
    },
  },
  paperSm: {
    height: '350px',
    maxWidth: '350px',
  },
}));

const getVideoStatus = () => {
  if (typeof document !== 'undefined') {
    return document.createElement('video');
  }
};

function ShortVideoPlayer(video_data) {
  const supportsVideo = !!getVideoStatus().canPlayType;
  const klipVideo = useRef(0);
  // video player
  const [progress, setProgress] = useState(0);
  const [muteState, setMuteState] = useState(true);
  const [, setVideoEnded] = useState(false);
  const [volume, setVolume] = useState(0.5);

  const [play, setPlayStatus] = useState('pause');

  // share modal
  const [modalStatus, setModalStatus] = useState(false);
  const [modalType, setModalType] = useState('');
  const modalClasses = useStyles();

  // check if user is loggedin
  const userToken = Cookies.get('token'); // token from cookies for logout
  const { loggedIn, setLoggedIn } = useContext(UserContext); // profile data - store

  // Login Modal Component states
  const [openModal, setOpenModal] = useState(false);

  // new functions and side effects for updating states inside the navbar
  const getLoggedInAction = useCallback((data) => {
    setLoggedIn(data.loggedIn);
    setOpenModal(data.modalStatus);
  }, [loggedIn, openModal]);

  const modalActions = useCallback((data) => {
    setOpenModal(data.modalStatus);
  }, [openModal]);

  const hostUrl = process.env.REACT_APP_KL2_URL;

  const branchKey = process.env.REACT_APP_BRANCH_KEY;

  // loads the video source without loading the page
  const previousUrl = useRef(video_data.data.video);
  useEffect(() => {
    if (previousUrl.current === video_data.data.video) {
      return;
    }

    if (klipVideo.current) {
      klipVideo.current.load();
      setPlayStatus('pause');
    }

    previousUrl.current = video_data.data.video;
  }, [video_data.data.video]);

  const swalWithButtons = Swal.mixin({
    customClass: {
      confirmButton: 'btn-okay-report',
      cancelButton: 'btn-cancel-report',
    },
    buttonsStyling: false,
  });

  const [copyLink, setCopyLink] = useState('');
  const history = useHistory();
  const handleCloseVideoPlayer = () => {
    history.push(`/${video_data.data.name}`);
  };

  const [banModalStatus, setBanModalStatus] = useState(false);
  const [userBanDetails, setUserBanDetails] = useState([]);
  const [banStatus, setBanStatus] = useState(loggedIn.user_status);

  const klipType = () => {
    if (video_data.product_ids) {
      return 'E-Commerce';
    }
    return 'Regular';
  };
  const handleSegmentTracking = async (socmedObj) => {
    const userShare = await getUser(loggedIn.username);
    const isStreamFollowing = () => userShare.data.data.relation_status === 5
        || userShare.data.data.relation_status === 1;
    const isStreamFeatured = () => userShare.data.data.type === 1;
    const musicName = video_data.data.music_name === '' ? null : video_data.data.music_name;
    const socMedShared = socmedObj.socmedType.charAt(0).toUpperCase()
        + socmedObj.socmedType.slice(1);
    window.analytics.track('Short Video Shared', {
      duration: video_data.data.dur,
      featured: isStreamFeatured(),
      feed_id: video_data.data.fid,
      following: isStreamFollowing(),
      host_id: video_data.data.uid,
      select_music: musicName,
      share_destination: socMedShared,
      share_link_generated: copyLink,
      short_video_type: klipType(),
    });
  };

  const checkBanStatus = async () => {
    if (banStatus === 'ban') {
      setBanModalStatus(true);
    } else if (banStatus === 'normal') {
      setModalType('report');
      setModalStatus(true);
    }
  };

  const loggedInUpdate = async () => {
    getUser(loggedIn.username)
      .then((userRes) => {
        if (userRes.data.code === '200') {
          setLoggedIn(userRes.data.data);
          setUserBanDetails(userRes.data.data.banDetails);
          setBanStatus(userRes.data.data.user_status);
          checkBanStatus();
        }
      })
      .catch((error) => {
        console.error(error);
      });
  };

  const handleOpen = (type) => {
    if (type === 'share') {
      setModalType('share');
      // load Branch
      const options = {};
      if (typeof window !== 'undefined') {
        // initialize branch using dynamic imports
        import('branch-sdk').then(({ default: branch }) => {
        // init Branch
          branch.init(branchKey, options, (_err, _data) => {
            branch.link({
              feature: 'share',
              data: {
                type: '1',
                userId: video_data.data.fid,
                $og_title: 'Follow this streamer on kumu!',
                $og_description: video_data.data.cnt,
                $og_imgurls: video_data.data.imgurls[0].image,
                title: 'Follow this streamer on kumu!',
                contentDescription: video_data.data.cnt,
                imageUrl: video_data.data.imgurls[0].image,
                userName: video_data.data.uid,
                shared_id: video_data.data.uid,
                sharer_id: loggedIn.guid === '' ? '' : loggedIn.guid,
                $desktop_url: `${hostUrl + video_data.data.name}/klips/${video_data.data.fid}`,
              },
            }, (_error, link) => {
              setCopyLink(link);
            });
          });
        });
      }
      setModalStatus(true);
    } else if (Object.entries(loggedIn).length === 0) {
      setOpenModal(true);
    } else if (Object.entries(loggedIn).length !== 0) {
      loggedInUpdate();
    }
  };
  const handleClose = () => {
    setModalStatus(false);
  };

  // share klip
  const deviceId = Cookies.get('deviceId');
  const formData = new FormData();

  const callbackShare = (response) => {
    if (response && !response.error_message) {
      alert('Posting completed.');
      formData.append('feed_id', video_data.data.fid);
      axios.post('/feed/share', formData, { headers: { 'device-id': `${deviceId}` } })
        .then(((response_messenger) => {
          if (response_messenger.status === 200) {
            if (response_messenger.data.code === '200') {
              return true;
            }
          }
        }))
        .catch((errorData) => {
          console.error(errorData);
        });
    } else {
      alert('Error while posting.');
    }
    return true;
  };
  const callbackWhatsApp = (newlink) => {
    window.open(newlink);

    formData.append('feed_id', video_data.data.fid);

    axios.post('/feed/share', formData, { headers: { 'device-id': `${deviceId}` } })
      .then(((response_whatsapp) => {
        if (response_whatsapp.status === 200) {
          if (response_whatsapp.data.code === '200') {
            return true;
          }
        }
      }))
      .catch((errorData) => {
        console.error(errorData);
      });
  };
  const shareToSocialAccount = async (socmedObj, err, link) => {
    if (/Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
      // on mobile browser
      window.open(socmedObj.mobile_new_link || err);
    } else if (socmedObj.socmedType === 'messenger' || socmedObj.socmedType === 'facebook') {
      if (socmedObj.socmedType === 'facebook') {
        window.FB.ui(
          {
            method: socmedObj.method,
            href: link,
          },
          (response) => {
            callbackShare(response);
          },
        );
      } else if (socmedObj.socmedType === 'messenger') {
        window.FB.ui(
          {
            method: socmedObj.method,
            link,
          },
          (response) => {
            callbackShare(response);
          },
        );
      }
    } else if (socmedObj.socmedType === 'whatsapp') {
      if (socmedObj.desktop_new_link) {
        callbackWhatsApp(socmedObj.desktop_new_link);
      }
    }
    await handleSegmentTracking(socmedObj);
  };
  const shareKlip = (socmed) => {
    const options = {};
    if (typeof window !== 'undefined') {
      // initialize branch using dynamic imports
      import('branch-sdk').then(({ default: branch }) => {
        branch.init(branchKey, options, (_err, _data) => {
          let sharer_id_val;
          if (loggedIn.length <= 0) {
            sharer_id_val = 'no_id';
          } else {
            sharer_id_val = loggedIn.guid;
          }
          branch.link({
            feature: 'share',
            data: {
              type: '1',
              userId: video_data.data.fid,
              $og_title: 'Follow this streamer on kumu!',
              $og_description: video_data.data.cnt,
              $og_imgurls: video_data.data.imgurls[0].image,
              title: 'Follow this streamer on kumu!',
              contentDescription: video_data.data.cnt,
              imageUrl: video_data.data.imgurls[0].image,
              userName: video_data.data.uid,
              shared_id: video_data.data.uid,
              sharer_id: sharer_id_val,
              $desktop_url: `${hostUrl + video_data.data.name}/klips/${video_data.data.fid}`,
            },
          }, (error, link) => {
            const socmedTypes = [
              {
                socmedType: 'facebook',
                mobile_new_link: `https://www.facebook.com/dialog/share?app_id=1983914755180097&display=popup&href=${link}&redirect_uri=${hostUrl}${video_data.data.name}/klips/${video_data.data.fid}`,
                method: 'share',
                desktop_new_link: '',
              },
              {
                socmedType: 'messenger',
                mobile_new_link: `fb-messenger://share?link=${link}`,
                method: 'send',
                desktop_new_link: '',
              },
              {
                socmedType: 'whatsapp',
                mobile_new_link: `whatsapp://send?text=${link}`,
                method: 'redirect',
                desktop_new_link: `https://web.whatsapp.com/send?text=${link}`,
              },
            ];
            const socmedTypeFound = socmedTypes.find((obj) => obj.socmedType === socmed);
            if (socmedTypeFound) {
              shareToSocialAccount(socmedTypeFound, error, link);
            }
          });
        });
      });
    }
  };

  const popUpMsg = 'Copied!';
  const [anchorEl, setAnchorEl] = React.useState(null);

  const appLink = useRef('');
  const copyAppLink = (event) => {
    handleSegmentTracking({ socmedType: 'Copy Link' }).then();
    appLink.current.select();
    navigator.clipboard.writeText(appLink.current.value);
    formData.append('feed_id', video_data.data.fid);
    axios.post('/feed/share', formData, { headers: { 'device-id': `${deviceId}` } })
      .then(((response) => {
        if (response.status === 200) {
          if (response.data.code === '200') {
            return true;
          }
        }
      }))
      .catch((error) => {
        console.error(error);
      });
    setAnchorEl(event.currentTarget);
    setTimeout(() => {
      setAnchorEl(null);
    }, 3000);
  };
  const closePopUp = () => {
    setAnchorEl(null);
  };
  const popOverOpen = Boolean(anchorEl);
  const popOver = popOverOpen ? 'simple-popover' : undefined;

  function reportKlip(type) {
    setModalStatus(false);
    swalWithButtons.fire({
      title: '<small class="titles">Report Klip</small>',
      text: 'Are you sure?',
      confirmButtonText: 'Yes',
      showCancelButton: true,
      cancelButtonText: 'No',
      reverseButtons: true,
    }).then((result) => {
      let option = '';
      const types = [
        {
          type: 'other',
          option: 0,
        },
        {
          type: 'inappropriate',
          option: 2,
        },
        {
          type: 'spam',
          option: 1,
        },
      ];
      if (result.isConfirmed) {
        const typeObject = types.find((obj) => obj.type === type);
        option = typeObject.option;
        formData.append('report_id', video_data.data.fid);
        formData.append('option', option);
        formData.append('imgurls', video_data.data.imgurls[0].image);
        axios.post('/live/report', formData, {
          headers: {
            'device-id': `${deviceId}`,
            'x-kumu-auth': `${userToken}`,
          },
        }).then((response) => {
          if (response.status === 200 && response.data.code === '200') {
            swalWithButtons.fire({
              icon: 'success',
              text: 'Report sent',
              confirmButtonText: 'Okay',
            });
          }
        }).catch((error) => {
          console.error(error);
        });
      } else {
        const new_link = 'https://kumu.zendesk.com/hc/en-us/requests/new';
        window.open(new_link, '_blank', 'noopener');
      }
    });
  }
  if (supportsVideo) {
    function playpause() {
      if (klipVideo.current.paused || klipVideo.current.ended) {
        klipVideo.current.play();
        setPlayStatus('pause');
      } else {
        klipVideo.current.pause();
        setPlayStatus('play');
      }
    }

    const videoEnded = () => {
      setVideoEnded(klipVideo.current.ended);
      setPlayStatus('replay');
    };

    // progress bar
    const handleOnTimeUpdate = () => {
      const progressTime = (klipVideo.current.currentTime / klipVideo.current.duration) * 100;
      setProgress(progressTime);
    };
    const handleVideoProgress = (event) => {
      const manualChange = Number(event.target.value);
      klipVideo.current.currentTime = (klipVideo.current.duration / 100) * manualChange;
      setProgress(manualChange);
    };

    // volume
    function mute() {
      if (muteState === false) {
        setMuteState(true);
      }
    }
    function unmute() {
      if (muteState) {
        setMuteState(false);
        setVolume(0.5);
      }
    }
    const alterVolume = (_event, newVolume) => {
      if (typeof document !== 'undefined') {
        const video = document.getElementById('video');
        video.volume = newVolume;
        setVolume(newVolume);
      }
    };
    function RenderMuteButton() {
      if (muteState) return <Button onClick={() => { unmute(); }} className='unmute'>Tap to unmute</Button>;
      return null;
    }
    const renderVolumeBtn = () => {
      if (muteState) return <Button onClick={() => { unmute(); }} className='volumeBtn'><VolumeOff /></Button>;
      return <Button onClick={() => { mute(); }} className='volumeBtn'><VolumeUp /></Button>;
    };
    const renderPlayerIcons = () => {
      if (play === 'play') return <PlayCircleOutlineOutlinedIcon />;
      if (play === 'pause') return <PauseCircleOutlineOutlinedIcon />;
      return <ReplayOutlinedIcon />;
    };
    const renderLoginModal = () => {
      if (openModal) {
        return (
          <LoginModalComponent
            isOpenModal={openModal}
            modalFunc={modalActions}
            loggedInFunc={getLoggedInAction}
            isOpenReCaptcha={video_data.data.isOpenReCaptcha}
          />
        );
      }
      return null;
    };
    const renderModalType = () => {
      if (modalType === 'report') {
        return (
          <div className={clsx(modalClasses.paper, [modalClasses.paper])}>
            <Grid className='reportModal-body'>
              <h2 className='titles'>Report Klip</h2>
              <Grid container justifyContent='space-between' alignItems='center' style={{ paddingTop: 10 }}>
                <Grid item lg={4} md={4} sm={12} xs={12} style={{ paddingTop: 2 }}>
                  <Button className='btn-report' onClick={() => { reportKlip('spam'); }}>Spam</Button>
                </Grid>
                <Grid item lg={4} md={4} sm={12} xs={12} style={{ paddingTop: 2 }}>
                  <Button className='btn-report' onClick={() => { reportKlip('inappropriate'); }}>Inappropriate</Button>
                </Grid>
                <Grid item lg={4} md={4} sm={12} xs={12} style={{ paddingTop: 2 }}>
                  <Button className='btn-report' onClick={() => { reportKlip('other'); }}>Other</Button>
                </Grid>
              </Grid>
              <Grid container justifyContent='space-between' alignItems='center' style={{ paddingTop: 45 }}>
                <Grid item lg={4} md={4} sm={4} xs={4} />
                <Grid item lg={4} md={4} sm={4} xs={4}>
                  <Button className='btn-close' onClick={handleClose}>Cancel</Button>
                </Grid>
                <Grid item lg={4} md={4} sm={4} xs={4} />

              </Grid>
            </Grid>
          </div>
        );
      }
      return (
        <div className={modalClasses.paper}>
          <Grid container className='shareModal-head'>
            <Grid item>
              <h2 className='share-title'>Share Klip</h2>
            </Grid>
            <Grid item>
              <Close onClick={handleClose} className='close-modal'>X</Close>
            </Grid>
          </Grid>
          <Grid container className='shareModal-body' justifyContent='space-between' alignItems='center'>
            <Grid item lg={4} md={4} sm={4}>
              <Link to='#' onClick={() => { shareKlip('messenger'); }} id='messenger'><img src={messenger} alt='msgr' /></Link>
            </Grid>
            <Grid item lg={4} md={4} sm={4}>
              <Link to='#' onClick={() => { shareKlip('facebook'); }} id='facebook'><img src={facebook} alt='fb' /></Link>
            </Grid>
            <Grid item lg={4} md={4} sm={4}>
              <Link to='#' onClick={() => { shareKlip('whatsapp'); }} id='whatsapp'><img src={whatsapp} alt='whatsapp' /></Link>
            </Grid>
            <Grid item lg={12} md={12} sm={12} xs={12}>
              <Typography>Copy Link</Typography>
              {/* <Button id="shareBtn" onClick={copyAppLink}>{copyLink}</Button> */}
              <input type='text' value={copyLink} ref={appLink} onClick={copyAppLink} className='copy-link-input' readOnly />

              {/* popover */}
              <Popover
                id={popOver}
                open={popOverOpen}
                anchorEl={anchorEl}
                onClose={closePopUp}
                anchorOrigin={{
                  vertical: 'bottom',
                  horizontal: 'left',
                }}
                transformOrigin={{
                  vertical: 'top',
                  horizontal: 'left',
                }}
              >
                <Typography>{popUpMsg}</Typography>
              </Popover>
            </Grid>
          </Grid>
        </div>
      );
    };
    return (
      <>
        {video_data.data.video
          ? (
            <div className='klip-player'>
              <figure>
                <video
                  id='video'
                  muted={muteState}
                  autoPlay
                  onEnded={() => { videoEnded(); }}
                  ref={klipVideo}
                  preload='metadata'
                  poster={video_data.data.imgurls[0].image}
                  onTimeUpdate={handleOnTimeUpdate}
                >
                  <source src={`https://vod2.kumuapi.com/${video_data.data.video}`} type='video/mp4' />
                </video>
              </figure>

              <Grid container className='klip-top-container'>
                <Grid item>
                  <RenderMuteButton />
                </Grid>
                <Grid item id='btnActions'>
                  <Button className='report' onClick={() => { handleOpen('report'); }} role='report-btn'><ReportIcon /></Button>
                  <Button onClick={handleCloseVideoPlayer} className='close'><HighlightOffIcon /></Button>
                </Grid>
              </Grid>

              <Button onClick={() => { playpause(); }} className='play'>
                {renderPlayerIcons()}
              </Button>

              <Grid container className='klip-bottom-container'>
                <Grid container className='volume-control'>
                  <Grid item>
                    {renderVolumeBtn()}
                  </Grid>
                  <Grid item xs>
                    <Slider value={volume} onChange={alterVolume} aria-labelledby='continuous-slider' min={0} max={1} step={0.1} />
                  </Grid>
                </Grid>

                <Grid item lg={10} md={10} sm={8} id='videoProgress'>
                  <input type='range' id='progress' onChange={(e) => handleVideoProgress(e)} value={progress} min='0' />
                </Grid>

                <Grid item lg={1} md={1} sm={1}>
                  <Button onClick={() => { handleOpen('share'); }} className='shareBtn'><ReplyOutlinedIcon /></Button>
                </Grid>
              </Grid>
              {renderLoginModal()}
              <Modal
                className={modalClasses.modal}
                open={modalStatus}
                closeAfterTransition
                BackdropComponent={Backdrop}
                BackdropProps={{
                  timeout: 500,
                }}
              >
                <Fade in={modalStatus}>
                  {renderModalType()}
                </Fade>
              </Modal>
            </div>
          )
          : (
            <div>
              Klip not found.
            </div>
          )}

        { banModalStatus === true ? <BanUser banModalStatus={banModalStatus} userBanDetails={userBanDetails} /> : '' }
      </>
    );
  }
}
export default ShortVideoPlayer;
